export default function ordinalNumberFormatter() {
  return (input:number ) => {

  	const inputString: string = input.toString()
  	const inputStringEnd: string = inputString.slice(inputString.length - 1);
  	let ordinalNumber: string;

    if (
    	inputStringEnd === '1' && input !== 11
    ) {
    	ordinalNumber = input + 'st';
    } else if (
    	inputStringEnd === '2' && input !== 12
    ) {
    	ordinalNumber = input + 'nd';
    } else if (
    	inputStringEnd === '3' && input !== 13
    ) {
    	ordinalNumber = input + 'rd';
    } else {
    	ordinalNumber = input + 'th';
    }

    return ordinalNumber;
  }
}


/** WEBPACK FOOTER **
 ** ./app/utils/ordinal-number.formatter.ts
 **/